import { IconButton } from '@material-ui/core';
import { Close as IconClose } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import * as React from 'react';

function SnackbarCloseButton({
  snackbarKey,
}: {
  snackbarKey: string | number | undefined;
}) {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton
      aria-label="close-snackbar-button"
      onClick={() => closeSnackbar(snackbarKey)}
    >
      <IconClose style={{ fill: 'white' }} />
    </IconButton>
  );
}

export default SnackbarCloseButton;
